export interface SupportContact {
  email: string;
  phone: string;
  workingHours: string;
}

export const defaultSupportContact: SupportContact = {
  email: 'organization@domain.ru',
  phone: '+7 (987) 654-32-10',
  workingHours: 'Пн–Пт, 10:00–18:00 МСК',
};
